import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $window,
        Alert,
        AddNewSharedPasswordModal,
        ImportSharedPasswordsModal,
        ManageSharedPasswordModal,
        ComputerAdministrationAccountShare,
        SharedAccountsService
    ) {
        this.$state = $state;
        this.$window = $window;
        this.Alert = Alert;
        this.AddNewSharedPasswordModal = AddNewSharedPasswordModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.ManageSharedPasswordModal = ManageSharedPasswordModal;
        this.ComputerAdministrationAccountShare = ComputerAdministrationAccountShare;
        this.SharedAccountsService = SharedAccountsService;
		this.st= new SmartTable();
    }

    $onInit() {
    }

    isComputerAdministrationAccount(account) {
        return account.publicService.serviceName == 'ComputerLocalAccountAdministration';
    }

    export(accounts) {
        let accountIds = accounts.map((item) => item.id);
        let companyId = this.companyId;
        this.SharedAccountsService.exportCompanyServiceAccounts({companyId}, accountIds)
                .$promise
                .then((response) => {
                    var file = new Blob([response.data], {
                        type : 'text/plain'
                    });
                    var windowUrl = this.$window.URL;
                    var fileURL = windowUrl.createObjectURL(file);
                    var a = document.createElement('a');
                    a.href = fileURL;
                    a.target = '_blank';
                    a.download = 'exported_passwords_' + new Date().valueOf() + '.csv';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function() { windowUrl.revokeObjectURL(fileURL); }, 100);
                    this.Alert('success', 'company.sharing-center.shared-accounts.export-succes');
                })
                .catch(error => {
                    this.Alert('danger', error.message);
                });

    }

    showManageModal(account) {
        this.ManageSharedPasswordModal(account).then(() => this.$state.reload(this.$state.current));
    }

    showAddModal() {
       /* this.publicServicesWithSso$.get()
            .then(items => this.AddNewSharedPasswordModal(items))
            .then(account => this.accounts.push(account))*/
            this.$state.go('company.sharing-center.add-shared-password');
    }

    showImportModal() {
        this.ImportSharedPasswordsModal().then(accounts => this.accounts.push(...accounts));
    }

    showShareModal(account) {
        if (this.isComputerAdministrationAccount(account)) {
            this.ComputerAdministrationAccountShare(account);
        } else {
            this.$state.go('company.sharing-center.shared-passwords.manage.share',{sharedAccount: account,sharedAccountId: account.id});
        }

    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/shared-passwords.controller.js